import { ProviderPageState, AdminProviderSearchModel } from './provider_list_types';
import { pageStateVM } from '../../../core/page/page_view_models';

import { validPropCheckboxVM } from '../../../core/components/validation/ValidCheckbox';
import { validPropMultiSelectVM } from '../../../core/components/validation/ValidInputMultiSelect';
import { validOptionalPropTextVM } from '../../../core/components/validation/ValidInputText';
import validSvc, { ValidOption } from '../../../core/validSvc';

// PAGE
export function providerPageStateVM(): ProviderPageState {
    return {
        ...pageStateVM(),
        action: '',
        ceOptions: [], // pre-loaded data on page load, see useProviderListInit
    };
}

// SEARCH
export function providerSearchStateVM(data?: AdminProviderSearchModel, ceOptions?: string[]): AdminProviderSearchModel {
    // note many search features support viewstate, that needs to be added as incoming "data" + preloaded data
    const ceValidOptions: ValidOption[] = ceOptions ? ceOptions.map(ce => ({ lbl: ce, val: ce })) : [];
    data = data || ({} as AdminProviderSearchModel);

    // see propval functions below for extracting values from possible viewstate props which could be missing completely
    return {
        CE: validPropMultiSelectVM('Facility', 'Facility', propArrayVal(data.CE, ['ALL']), 'CE', ceValidOptions),
        NPI: validOptionalPropTextVM('NPI', 'NPI', propTextVal(data.NPI), '', propChecked(data.NPI)),
        FullName: validOptionalPropTextVM(
            'FullName',
            'Full Name',
            propTextVal(data.FullName),
            '',
            propChecked(data.FullName),
        ),
        Validated: validPropCheckboxVM('Validated', 'Validated', propBoolVal(data.Validated)),
        FaxConsent: validPropCheckboxVM('FaxConsent', 'Fax Consent', propBoolVal(data.FaxConsent)),
    };
}

function propTextVal(prop: any): string {
    if (!!prop && validSvc.isText(prop.val)) {
        return prop.val as string;
    }
    return '';
}

function propBoolVal(prop: any): boolean {
    return !!prop && !!prop.val;
}

function propArrayVal(prop: any, defaultValue: any[] = []): any[] {
    if (!!prop && Array.isArray(prop.val)) {
        return prop.val as any[];
    }
    return defaultValue;
}

function propChecked(prop: any): boolean {
    return !!prop && prop.checked;
}
